var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(-21281 -17572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(21281 17572)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "information-button_2_",
    "data-name": "information-button (2)",
    transform: "translate(21283.4 17574.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M9.6,0a9.6,9.6,0,1,0,9.6,9.6A9.6,9.6,0,0,0,9.6,0Zm2,14.878q-.741.293-1.182.445a3.119,3.119,0,0,1-1.026.154,2.044,2.044,0,0,1-1.4-.438,1.414,1.414,0,0,1-.5-1.111,4.035,4.035,0,0,1,.037-.536c.025-.182.065-.387.119-.617l.618-2.185c.054-.21.1-.409.139-.594a2.634,2.634,0,0,0,.055-.514A.792.792,0,0,0,8.294,8.9a.979.979,0,0,0-.661-.163,1.734,1.734,0,0,0-.492.073c-.167.051-.311.1-.43.143l.163-.673q.607-.247,1.162-.423a3.433,3.433,0,0,1,1.048-.177,2.006,2.006,0,0,1,1.375.431,1.431,1.431,0,0,1,.483,1.118q0,.143-.033.5a3.355,3.355,0,0,1-.124.659l-.615,2.178c-.05.175-.1.375-.136.6a3.163,3.163,0,0,0-.059.509.731.731,0,0,0,.194.592,1.087,1.087,0,0,0,.672.158,1.949,1.949,0,0,0,.509-.079,2.893,2.893,0,0,0,.411-.138Zm-.109-8.841a1.468,1.468,0,0,1-1.036.4,1.484,1.484,0,0,1-1.04-.4,1.276,1.276,0,0,1-.433-.97A1.289,1.289,0,0,1,9.413,4.1a1.473,1.473,0,0,1,1.04-.4,1.456,1.456,0,0,1,1.036.4,1.309,1.309,0,0,1,0,1.942Z",
    fill: "#438afe"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.32b4127e99cc99df7ee160d0d848aa8b.svg";
export { ForwardRef as ReactComponent };